import EventEmitter from 'events'
const EVENTS_URL = process.env.EVENTS_URL

class EventsSubscribersClient extends EventEmitter {
  constructor () {
    super()
    this._isConnected = false
    this._url = EVENTS_URL
    this._socket = {}
  }
  get isConnected () {
    return this._isConnected
  }
  connect () {
    const token = localStorage.getItem('heimdall-session-token')
    this._socket = new WebSocket(`${this._url}?token=${token}`)
    this._socket.onerror = err => {
      console.error(err)
    }
    this._socket.onopen = event => {
      this._isConnected = true
      this.emit('connection', event)
    }
    this._socket.onmessage = message => {
      const data = JSON.parse(message.data)
      const notification = data.notification
      this.emit(notification, data[notification])
    }
  }
  subscribe () {
    this._socket.send(JSON.stringify({
      event: 'subscribe-to-events-room'
    }))
  }
  subscribeToPositions () {
    this._socket.send(JSON.stringify({
      event: 'subscribe-to-positions-room'
    }))
  }
  unsubscribe () {
    if (this._socket.readyState !== 1) {
      return false
    }
    this._socket.send(JSON.stringify({
      event: 'unsubscribe-from-events-room'
    }))
  }
  watchVehicle (vehicleId) {
    this._socket.send(JSON.stringify({
      event: 'update-watched-vehicle',
      vehicleId
    }))
  }
  watchVehiclesPositions (vehicles) {
    this._socket.send(JSON.stringify({
      event: 'watch-vehicles-positions',
      vehicles
    }))
  }
}

export default EventsSubscribersClient



// WEBPACK FOOTER //
// ./src/api/events.js